import { createRadarWorldTransform } from "../radar-transform.js";
const missingRuntimeRequirements = [
    "openings",
    "portals",
    "materials",
];
function setupManifest(source) {
    return {
        manifestVersion: 1,
        status: "setup_required",
        mapId: source.mapId,
        mapRevision: source.mapRevision,
        radar: {
            path: `assets/maps/de_${source.mapId}_radar.png`,
            sha256: source.radarSha256,
            widthPixels: 1024,
            heightPixels: 1024,
        },
        radarTransform: createRadarWorldTransform({
            posXHu: source.posXHu,
            posYHu: source.posYHu,
            scaleHuPerPixel: source.scaleHuPerPixel,
            widthPixels: 1024,
            heightPixels: 1024,
        }),
        layers: source.layers ?? [
            {
                id: "main",
                label: "Main",
                minZHu: source.minZHu,
                maxZHu: source.maxZHu,
            },
        ],
        source: {
            manifestPath: `assets/physics/manifests/${source.mapId}.json`,
            cs2BuildId: "24537688",
            triangleCount: source.triangleCount,
        },
        missing: missingRuntimeRequirements,
    };
}
export const mapPhysicsSetupManifests = [
    setupManifest({
        mapId: "ancient",
        mapRevision: "Radar importiert · Callouts ausstehend",
        radarSha256: "f27c798796f43f76c88a556d0a9a2c3617c6cc9b57054fefaf3b3afabbcb42cb",
        triangleCount: 967742,
        posXHu: -2953,
        posYHu: 2164,
        scaleHuPerPixel: 5,
        minZHu: -229.00003,
        maxZHu: 1425.8499755859375,
    }),
    setupManifest({
        mapId: "anubis",
        mapRevision: "Radar importiert · Callouts ausstehend",
        radarSha256: "8b7edec08863a6d58c9de80dcba453c6e4cb7e6c79d734c8fca3dff102b19473",
        triangleCount: 765726,
        posXHu: -2796,
        posYHu: 3328,
        scaleHuPerPixel: 5.22,
        minZHu: -704,
        maxZHu: 1152,
    }),
    setupManifest({
        mapId: "cache",
        mapRevision: "Radar importiert · Callouts ausstehend",
        radarSha256: "fa86121de95cde81a182f7195a9be02f0ad753a606bf459634a4471c644d5af2",
        triangleCount: 1632023,
        posXHu: -2000,
        posYHu: 3250,
        scaleHuPerPixel: 5.5,
        minZHu: 1524,
        maxZHu: 3330.922607421875,
    }),
    setupManifest({
        mapId: "inferno",
        mapRevision: "Video Playbook · 02.08.2026",
        radarSha256: "53e1d660d5e61a9b876cc56725c2e891c56efcb788657520fa9c10fec321dce3",
        triangleCount: 2733603,
        posXHu: -2087,
        posYHu: 3870,
        scaleHuPerPixel: 4.9,
        minZHu: -280.00006103515625,
        maxZHu: 1624.0001220703125,
    }),
    setupManifest({
        mapId: "mirage",
        mapRevision: "Mirage · Stand 2026-08 · Practice-Prüfung offen",
        radarSha256: "c8032f6c83ffca63c0a20ebdcc598a0e1aa618efd746e381e2db26f33a4a964f",
        triangleCount: 133131,
        posXHu: -3230,
        posYHu: 1713,
        scaleHuPerPixel: 5,
        minZHu: -448,
        maxZHu: 1024,
    }),
    setupManifest({
        mapId: "nuke",
        mapRevision: "Radar importiert · Callouts ausstehend",
        radarSha256: "49b85627868edd850a861a466f211eb35050f74d1b0e03a71a4e85c83c361b9a",
        triangleCount: 191628,
        posXHu: -3453,
        posYHu: 2887,
        scaleHuPerPixel: 7,
        minZHu: -1216,
        maxZHu: 808.000244140625,
        layers: [
            { id: "default", label: "Default", minZHu: -495, maxZHu: 10000 },
            { id: "lower", label: "Lower", minZHu: -10000, maxZHu: -495 },
        ],
    }),
    setupManifest({
        mapId: "overpass",
        mapRevision: "Radar importiert · Callouts ausstehend",
        radarSha256: "056a5a5a5f83db9c664eb1b370b93463f26f7708500e3e3b83a0028f67e62096",
        triangleCount: 1390717,
        posXHu: -4831,
        posYHu: 1781,
        scaleHuPerPixel: 5.2,
        minZHu: -44,
        maxZHu: 2549.51904296875,
    }),
    setupManifest({
        mapId: "train",
        mapRevision: "Radar importiert · Callouts ausstehend",
        radarSha256: "a38b8827a6a21f9f95939076f35e10948cdccedd5848663302ea2e3d1fa18971",
        triangleCount: 1574210,
        posXHu: -2308,
        posYHu: 2078,
        scaleHuPerPixel: 4.082077,
        minZHu: -568,
        maxZHu: 808,
        layers: [
            { id: "default", label: "Default", minZHu: -50, maxZHu: 20000 },
            { id: "lower", label: "Lower", minZHu: -5000, maxZHu: -50 },
        ],
    }),
    setupManifest({
        mapId: "vertigo",
        mapRevision: "Radar importiert · Callouts ausstehend",
        radarSha256: "0a89cb5850b2069b09e559850f01e320d639f42b67d06993b4983959cc2cfba6",
        triangleCount: 210596,
        posXHu: -3168,
        posYHu: 1762,
        scaleHuPerPixel: 4,
        minZHu: -992,
        maxZHu: 15368,
        layers: [
            { id: "default", label: "Default", minZHu: 11700, maxZHu: 20000 },
            { id: "lower", label: "Lower", minZHu: -10000, maxZHu: 11700 },
        ],
    }),
];
